<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/service-products/services" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ viewService.serviceType }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editservice(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteservicemastersPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ServiceCode") }}</b>
                    </td>
                    <td>{{ viewService.serviceCode }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ServiceDescription") }}</b>
                    </td>
                    <td>{{ viewService.serviceDescription }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ServiceCategory") }}</b>
                    </td>
                    <td>{{ viewService.serviceCategory }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Status") }}</b>
                    </td>
                    <td>{{ viewService.serviceStatus }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Isoptional") }}</b>
                    </td>
                    <td>{{ viewService.isOptional }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.Isautoprovision") }} </b>
                    </td>
                    <td class="border-none">
                      {{ viewService.isAutoProvision }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <h3>{{ $t("setup.label.ServiceParameter") }}</h3>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full mt-6 table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ParamName") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ParamType") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ParamCategory") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ParamValue") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(service, index) in viewService.serviceDetailDatas"
                    :key="index"
                  >
                    <td>{{ service.codeParamName }}</td>
                    <td>{{ service.paramType }}</td>
                    <td>{{ service.paramCategory }}</td>
                    <td>{{ service.paramValue }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteservicemastersPopup"
      :title="$t('setup.label.Services')"
      @deletePressed="deleteservicemasters()"
      @cancelPressed="deleteservicemastersPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      id: "",
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteservicemastersPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      viewService: (state) => state.serviceProducts.viewService,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editservice() {
      this.$router.push({ name: "Edit Service", params: { id: this.id } });
    },
    async deleteservicemasters() {
      this.deleteservicemastersPopup = false;
      await this.$store.dispatch(
        "serviceProducts/deleteservicemastersAction",
        this.$route.params.id
      );
      this.$toasted.success("Deleted Successfully");
      this.$router.push(`/setup/service-products/services`);
    },

    async getservicemasters() {
      try {
        await this.$store.dispatch(
          "serviceProducts/setservicemasters",
          this.$route.params.id
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getservicemasters();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
